import { render, staticRenderFns } from "./WebCart.vue?vue&type=template&id=52ea74ca&scoped=true&"
import script from "./WebCart.vue?vue&type=script&lang=js&"
export * from "./WebCart.vue?vue&type=script&lang=js&"
import style0 from "./WebCart.vue?vue&type=style&index=0&id=52ea74ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ea74ca",
  null
  
)

export default component.exports